var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4Mat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 360 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#eccc3b;}.cls-4{fill:#d6504d;}.cls-5{fill:#abd64d;}.cls-6{fill:#4db7d6;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-460 -332)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 460,
    y: 332,
    width: 360,
    height: 360,
    rx: 15,
    ry: 15
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Untitled-3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 360,
    height: 360
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 180,
    width: 180,
    height: 180
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    y: 180,
    width: 180,
    height: 180
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 180,
    y: 180,
    width: 180,
    height: 180
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4Mat);
export default __webpack_public_path__ + "static/media/icon_4mat.3ee2afe7c57d5edb0523174304a07e02.svg";
export { ForwardRef as ReactComponent };